import { render, staticRenderFns } from "./reisetermin-passdaten-konfiguration-table.vue?vue&type=template&id=4bf1691a&scoped=true"
import script from "./reisetermin-passdaten-konfiguration-table.vue?vue&type=script&lang=js"
export * from "./reisetermin-passdaten-konfiguration-table.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-passdaten-konfiguration-table.vue?vue&type=style&index=0&id=4bf1691a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf1691a",
  null
  
)

export default component.exports